import React from 'react';
import { Component } from 'react';
import './PriceScreen.scss';
import { SimpleButton } from '../../buttons/simple/SimpleButton';
import { TextButton } from '../../buttons/text/TextButton';
import { DownloadButtons } from '../../buttons/download/DownloadButtons';

interface PriceScreenProps {
}

interface PriceScreenState {
    showRecurringPricing: boolean;
    showDownloadButtons: boolean;
}

export default class PriceScreen extends Component<PriceScreenProps, PriceScreenState> {
    constructor(props: PriceScreenProps) {
        super(props);

        this.state = {
            showRecurringPricing: true,
            showDownloadButtons: false
        };
    }

    private openStoreWebsite() {
        window.open("https://multivoucher.pl/produkt/karta-podarunkowa-mediti/", "_blank");
    }

    private isBeforeOrEqualToTargetDate(targetDateString: string): boolean {
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        const targetDate = new Date(targetDateString);

        return currentDate <= targetDate;
    }

    public render() {
        let { showRecurringPricing, showDownloadButtons } = this.state;
        let basicPrice = 25;
        let canUserBuyPacket = true;
        let promoLastDay = '2025-08-31';

        return (
            <div className="price-container">
                <div className="row">
                    <div className="col">
                        <div className="title">
                            <h2 className="title-desc">Sięgnij po pakiet Mediti Premium i uzyskaj dostęp do pełnej oferty Mediti</h2>
                            <h3 className="title-header gold-text">Dostępne subskrypcje</h3>
                        </div>
                    </div>
                </div>

                <div className="price-list-toggle">
                    <div className="row">
                        <div className="col">
                            {(() => {
                                if (showRecurringPricing) {
                                    return (
                                        <>
                                            <SimpleButton
                                                text="Płatność co miesiąc"
                                                onClick={(e) => this.setState({ showRecurringPricing: true })}
                                            />
                                            <TextButton
                                                text="Płatność z góry"
                                                onClick={(e) => this.setState({ showRecurringPricing: false, showDownloadButtons: false })}
                                            />
                                        </>
                                    );
                                }
                                return (
                                    <>
                                        <TextButton
                                            text="Płatność co miesiąc"
                                            onClick={(e) => this.setState({ showRecurringPricing: true })}
                                        />
                                        <SimpleButton
                                            text="Płatność z góry"
                                            onClick={(e) => this.setState({ showRecurringPricing: false })}
                                        />
                                    </>
                                );
                            })()}

                        </div>
                    </div>
                </div>

                {(() => {
                    if (showRecurringPricing) {
                        return (
                            <div className="row justify-content-center">
                                <div className="col-12 col-xl-4">
                                    <div className="price-list-element">
                                        <div className="price-list-element-header">
                                            <p className="months">1 miesiąc</p>
                                            {(() => {
                                                if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                    return (<p className="price"><span className="crossed-text">{basicPrice} zł</span> 39 zł</p>);
                                                } else {
                                                    return (<p className="price"><span className="crossed-text">39 zł</span> {basicPrice} zł</p>);
                                                }
                                            })()}
                                        </div>
                                        <div className="price-list-element-desc">
                                            <ul>
                                                <li>Nielimitowany dostęp do pełnego katalogu medytacji Mediti</li>
                                                <li>Możliwość korzystania na 2 niezależnych urządzeniach</li>
                                                <li>Dostęp do Mediti na urządzeniach iOS oraz Android</li>
                                                {(() => {
                                                    if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                        return (<li><span className="crossed-text">1,30 zł</span> 0,83 zł dziennie</li>);
                                                    } else {
                                                        return (<li>0,83 zł dziennie</li>);
                                                    }
                                                })()}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    return (
                        <div className="row justify-content-center">
                            <div className="col-12 col-xl-4">
                                <div className="price-list-element">
                                    <div className="price-list-element-header">
                                        <p className="months">1 miesiąc</p>
                                        {(() => {
                                            if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                return (<p className="price"><span className="crossed-text">{basicPrice} zł</span> 39 zł</p>);
                                            } else {
                                                return (<p className="price"><span className="crossed-text">39 zł</span> {basicPrice} zł</p>);
                                            }
                                        })()}
                                    </div>
                                    <div className="price-list-element-desc">
                                        <ul>
                                            <li>Nielimitowany dostęp do pełnego katalogu medytacji Mediti</li>
                                            <li>Możliwość korzystania na 2 niezależnych urządzeniach</li>
                                            <li>Dostęp do Mediti na urządzeniach iOS oraz Android</li>
                                            {(() => {
                                                if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                    return (<li><span className="crossed-text">1,30 zł</span> 0,83 zł dziennie</li>);
                                                } else {
                                                    return (<li>0,83 zł dziennie</li>);
                                                }
                                            })()}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-4">
                                <div className="price-list-element">
                                    <div className="price-list-element-header">
                                        <p className="months">3 miesiące</p>
                                        {(() => {
                                            if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                return (<p className="price"><span className="crossed-text">75 zł</span> 65 zł</p>);
                                            } else {
                                                return (<p className="price"><span className="crossed-text">{basicPrice * 3} zł</span> 65 zł</p>);
                                            }
                                        })()}
                                    </div>
                                    <div className="price-list-element-desc">
                                        <ul>
                                            <li>Nielimitowany dostęp do pełnego katalogu medytacji Mediti</li>
                                            <li>Możliwość korzystania na 2 niezależnych urządzeniach</li>
                                            <li>Dostęp do Mediti na urządzeniach iOS oraz Android</li>
                                            {(() => {
                                                if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                    return (<li><span className="crossed-text">1,10 zł</span> 0,91 zł dziennie</li>);
                                                } else {
                                                    return (<li>0,72 zł dziennie</li>);
                                                }
                                            })()}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-4">
                                <div className="price-list-element">
                                    <div className="price-list-element-header">
                                        <p className="months">12 miesięcy</p>
                                        {(() => {
                                            if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                return (<p className="price"><span className="crossed-text">320 zł</span> 259 zł</p>);
                                            } else {
                                                return (<p className="price"><span className="crossed-text">{basicPrice * 12} zł</span> 250 zł</p>);
                                            }
                                        })()}
                                    </div>
                                    <div className="price-list-element-desc">
                                        <ul>
                                            <li>Nielimitowany dostęp do pełnego katalogu medytacji Mediti</li>
                                            <li>Możliwość korzystania na 2 niezależnych urządzeniach</li>
                                            <li>Dostęp do Mediti na urządzeniach iOS oraz Android</li>
                                            {(() => {
                                                if (this.isBeforeOrEqualToTargetDate(promoLastDay)) {
                                                    return (<li><span className="crossed-text">0,88 zł</span> 0,72 zł dziennie</li>);
                                                } else {
                                                    return (<li>0,69 zł dziennie</li>);
                                                }
                                            })()}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })()}

                <div className="row">
                    <div className="col">
                        <div className="footer">
                            {(() => {
                                if (showRecurringPricing && !showDownloadButtons) {
                                    return (
                                        <div>
                                            <p className="footer-text1">Chcesz uzyskać dostęp do Mediti Premium?</p>
                                            <div className="buy-now">
                                                <SimpleButton
                                                    text="Wypróbuj przez 7 dni za darmo!"
                                                    onClick={(e) => this.setState({ showDownloadButtons: true })}
                                                />
                                            </div>
                                        </div>);
                                }
                                else if (showRecurringPricing && showDownloadButtons) {
                                    return (
                                        <div>
                                            <DownloadButtons />
                                        </div>
                                    );
                                }
                                else {
                                    return (
                                        <div>
                                            <p className="footer-text1">Chcesz uzyskać dostęp do Mediti Premium?</p>
                                            <div className="buy-now">
                                                <SimpleButton
                                                    text="Kup teraz"
                                                    onClick={(e) => this.openStoreWebsite()}
                                                />
                                            </div>
                                        </div>);
                                }
                            })()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}